const Constants = {
  APP_NAME: 'Signature Creator',
  APP_URL: 'https://signatur.aluxus.de',
};

export default Constants;
